export interface ResponseFormat<T> {
  data: T;
  status: number;
  message: string;
  errors?: Array<string>;
}

export interface EventFormat<T> {
  data: T;
  event: 'DEQUEUE_TASK | NEW_SURVIVORS_MESSAGE';
}

export const EventTypes = {
  DEQUEUE_TASK: 'DEQUEUE_TASK',
  NEW_SURVIVORS_MESSAGE: 'NEW_SURVIVORS_MESSAGE',
  WEBCHAT_END: 'WEBCHAT_END',
  WEBCHAT_CANCEL: 'WEBCHAT_CANCEL',
};

export interface HotlineMetaData {
  endpointTitle?:string,
  endpointLogo?:string,
  endpointLang?:string,
  status: boolean
}

export interface HotlinePageData {
  clientLogo: string;
  clientName: string;
  title: string;
  subTitle: string;
  phoneNumber: string;
  bannerTitle: string;
  bannerInfoText: string;
  headerLogo?: string;
  bannerBackgroundImage?: string;
  bannerBackgroundColor?: string;
  fontColor?: string;
  chatNowBtnColor?: string;
  bannerTitleColor?: string;
  bannerContent: string;
  services: Service[];
  moreInfo: MoreInfo[];
  footerLinks: Menus[];
  menuLinks?: Menus[];
  bannerImgUrl: string;
  footerBgColor?: string;
  footerContent?: string;
  lastUpdatedDate: string;
  emergencyPhNo?: string;
  subTitleColor?: string;
  titleColor?: string;
  headerBgImg?: string;
  headerBgColor?: string;
}
export interface Menus {
  label: string;
  url: string;
}
export interface Service {
  planTitle: string;
  content: string;
  btnTitle: string;
  btnLink: string;
  additionalContent?: string;
  icon: string;
  readMoreText?: string;
}

export interface MoreInfo {
  title: string;
  titleLink: string;
  content: string;
  linkTitle: string;
  link: string;
}
